import { getCurrentInstance, type FunctionalComponent, defineComponent, getCurrentScope, onScopeDispose } from 'vue'
import { hashAnyu32 } from '../hash'

export const getComponentUID = (useParent?: boolean): number => {
  const instance = getCurrentInstance()
  if (!instance) return -1
  if (useParent && instance.parent) return instance.parent.uid
  return instance.uid
}

export const getScopedClass = (useParent?: boolean): string => {
  let uid = getComponentUID(useParent)
  if (uid <= -1) {
    // hack to get the stack, and produce a unique id from it
    const err = new Error()
    uid = hashAnyu32(err.stack || err.message || err.name)
  }

  return `component-${uid}`
}

export const anonymousComponent = <PropsType = any>(fun: () => FunctionalComponent<PropsType>) => {
  return defineComponent<PropsType>({
    setup() {
      const render = fun()
      return render
    }
  })
}

export const isComponentScope = (): boolean => {
  try {
    const instance = getCurrentInstance()
    return !!instance && !!instance.proxy;
  } catch (e) {
    return false
  }
}

export const onDispose = (fun: (() => void | Promise<void>)) => {
  if (getCurrentScope()) {
    onScopeDispose(() => {
      fun();
    })
  }
}
